import clsx from 'clsx';
import style from './style.module.scss';

export const SelectGender = ({ className, gender, setGender, forceOneLine = false, ...props }) => {
    return (
        <div className={clsx(style.gender, className, forceOneLine && style.oneLine)} {...props}>
            <div
                onClick={() => setGender('female')}
                className={clsx(
                    gender === 'female' ? style.choosed : style.notChoosed,
                    forceOneLine && style.oneLineItem,
                )}
            >
                MADAME
            </div>
            <div
                onClick={() => setGender('male')}
                className={clsx(
                    gender === 'male' ? style.choosed : style.notChoosed,
                    forceOneLine && style.oneLineItem,
                )}
            >
                MONSIEUR
            </div>
            <div
                onClick={() => setGender('neutral')}
                className={clsx(
                    gender === 'neutral' ? style.choosed : style.notChoosed,
                    forceOneLine && style.oneLineItem,
                )}
            >
                JE PRÉFÈRE NE PAS LE DIRE
            </div>
        </div>
    );
};
